// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"4a81b08a","239":"7c9cb757","453":"83bc9068","732":"cf97a9eb","977":"0ebd078b"}[chunkId] + ".chunk.js";
};